import { defineMessages } from 'react-intl';

export const i18n: {
	featuredCategoryName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	popularCategoryName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	myTemplatesCategoryName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	featuredCategoryName: {
		id: 'category-selector.featured.category.name',
		defaultMessage: 'Featured',
		description: 'Text for the name of `Featured` category',
	},
	popularCategoryName: {
		id: 'category-selector.popular.category.name',
		defaultMessage: 'Popular',
		description:
			'The text is shown as a category label in the template category selector, representing the category that groups the most frequently used or trending templates.',
	},
	myTemplatesCategoryName: {
		id: 'category-selector.my-templates.category.name',
		defaultMessage: 'My Templates',
		description: 'Text for the name of `My Templates` category',
	},
});
